import supabase from "../../../shared/database/supabase";
import { toInclusiveTimestampRange } from "../../../shared/lib/date-range";
import { PericiaInvoiceItem } from "..";

export interface ListPericiasByDateRangeRequest {
  start: Date;
  end: Date;
  page: number;
  filters: {
    done: boolean;
    not_done: boolean;
    price_calculated: boolean;
    billed: boolean;
  };
}

export const listPericiasByDateRange = async (req: ListPericiasByDateRangeRequest): Promise<PericiaInvoiceItem[]> => {
  try {
    const range = toInclusiveTimestampRange({ start: req.start, end: req.end });
    const { data, error } = await supabase.functions.invoke("list-pericias-by-date-range", {
      body: JSON.stringify({ ...req, start: range.start, end: range.end })
    });

    if (error) throw error;
    if (!data || data.length === 0) {
      return [];
    }

    return data.map((pericia: PericiaInvoiceItem) => ({
      ...pericia,
      createdAt: new Date(pericia.createdAt),
      updatedAt: new Date(pericia.updatedAt),
      date: new Date(pericia.date)
    }));
  } catch (err) {
    console.log(err);
    throw err;
  }
};
